import { useState } from "react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    organization: "",
    email: "",
    phone: "",
    message: "",
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const encode = (data) => {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]),
      )
      .join("&");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      const response = await fetch("/", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: encode({
          "form-name": "contact",
          ...formData,
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      setFormData({
        organization: "",
        email: "",
        phone: "",
        message: "",
      });

      setSuccessMessage("Tack! Ditt meddelande har skickats.");
      setTimeout(() => setSuccessMessage(""), 4000);
    } catch (error) {
      setErrorMessage("Något gick fel. Försök igen.");
    }

    setLoading(false);
  };

  return (
    <form
      name="contact"
      method="POST"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      onSubmit={handleSubmit}
      className="space-y-4"
    >
      <input type="hidden" name="form-name" value="contact" />
      <input type="hidden" name="bot-field" />

      <div>
        <label className="block text-sm font-medium mb-2">
          Organisation / Företag
        </label>
        <Input
          type="text"
          name="organization"
          value={formData.organization}
          onChange={handleChange}
          className="bg-background border-foreground/20"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">Mejl</label>
        <Input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          className="bg-background border-foreground/20"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">Telefonnummer</label>
        <Input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          className="bg-background border-foreground/20"
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">Meddelande</label>
        <Textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          className="bg-background border-foreground/20 min-h-[150px]"
          required
        />
      </div>

      {successMessage && (
        <div className="p-4 bg-green-100 text-green-800 rounded-lg">
          {successMessage}
        </div>
      )}

      {errorMessage && (
        <div className="p-4 bg-red-100 text-red-800 rounded-lg">
          {errorMessage}
        </div>
      )}

      <Button
        type="submit"
        disabled={loading}
        className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold"
      >
        {loading ? "Skickar..." : "Skicka"}
      </Button>
    </form>
  );
};

export default ContactForm;
